import { BrowserRouter } from 'react-router-dom'
import { AppRouter } from './routes'
import { QueryClientProvider } from '@tanstack/react-query'
import { AuthProvider } from './features/auth/components/auth-provider'
import { queryClient } from './config/query-client'
import { TenancyProvider } from '$features/auth/components/tenancy-provider'
import { Toaster } from 'react-hot-toast'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { ModalRegistryProvider } from './contexts/modal-registry'
import { GtagUserIdSync } from './components/gtag-user-id-sync'

export function App() {

  return (
    <QueryClientProvider client={queryClient}>
      <Toaster position="top-center" />

      <ModalRegistryProvider>
        <AuthProvider>
          <GtagUserIdSync />
          <TenancyProvider>
            <BrowserRouter>
              <AppRouter />
            </BrowserRouter>
          </TenancyProvider>
        </AuthProvider>
      </ModalRegistryProvider>

      {/* Dev Tools */}
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  )
}

export default App
